import { Injectable, Signal } from "@angular/core";
import { Store } from "@ngrx/store";
import { CartModel } from "../../../store/cart/cart.model";
import { CartData, Product } from "../cart-apis/interfaces/get-cart.interface";
import { firstValueFrom, map, Observable } from "rxjs";
import { selectCartData, selectCartTotal, selectEstablishmentName } from "../../../store/cart/cart.selectors";
import { setCart } from "../../../store/cart/cart.actions";
import { ProductsAble, ProductsIDsDisable } from "../pre-purchase/interfaces/pre-purchase.interface";

@Injectable({
  providedIn: 'root'
})
export class CartStorageService {
  products: Product[] = [];

  constructor(
    private store: Store<{ cart: CartModel }>
  ) {

  }


  getCartInfo() {
    this.store.select(state => state.cart.CartData).subscribe(cart => {
      // console.log('cart:', cart);
    });
  }
  getProudcts(): Product[] {
    this.store.select(state => state.cart.CartData?.products).pipe(
      map(products => {
        if (products) {
          this.products = products;

        }
      })
    )
    return this.products;
  }


  getTotal(): any {
    this.store.select(selectCartTotal).subscribe(total => {
      return total;
    });
  }










  async updateCart(products: Array<{ pd_id: string | number }>) {
    const idsProducts = products.map(product => product.pd_id.toString());
    // console.log('id de productos que se van del carrito', products);

    const currentCart = await firstValueFrom(this.store.select(selectCartData));
    // console.log('carrito actual que tengo', currentCart);

    const enabledProducts = currentCart.products.filter(cartProduct =>
      !idsProducts.includes(cartProduct.product_id.toString())
    );

    const newTotal = enabledProducts.reduce((sum, product) => sum + product.subtotal, 0);

    const updatedCart: CartData = {
      cart_id: currentCart.cart_id,
      establishment_name: currentCart.establishment_name,
      establishment_id: currentCart.establishment_id,
      products: enabledProducts,
      total: newTotal
    };

    // console.log('Carrito actualizado:', updatedCart);
    this.store.dispatch(setCart({ CartData: updatedCart }));
  }





}
